export function httpToHttps(url: string) {
  return url.replace('http://', 'https://')
}
